import dayjs from "dayjs";

export class LeagueFilter {
   startDateFrom?:number;
   startDateTo?: number;
   sportId?:number;
   countryId?:number;
   leagueStatus?:number;
   name?:string;

  public static leagueCalendarParams(): LeagueFilter {
    let startDate: dayjs.Dayjs = dayjs().add(-1, 'years');
    let endDate: dayjs.Dayjs = dayjs().add(1, 'years');

    let leagueFilter:LeagueFilter = new LeagueFilter();
    leagueFilter.startDateFrom = startDate.toDate().getTime();
    leagueFilter.startDateTo = endDate.toDate().getTime();
    return leagueFilter;
  }
}
